// useAuthTokenRedirect.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthTokenRedirect = (authToken: unknown) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if authToken is not present
    if (!authToken) {
      navigate('*'); // The path to your <PunditWelcomePage>
    }
  }, [authToken, navigate]);
};

export default useAuthTokenRedirect;
